import { render, staticRenderFns } from "./CreditNoteEdit.vue?vue&type=template&id=f1038ac0&scoped=true"
import script from "./CreditNoteEdit.vue?vue&type=script&lang=js"
export * from "./CreditNoteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1038ac0",
  null
  
)

export default component.exports